export const SEND_INVITATION_ACTION = 'SEND_INVITATION_ACTION'
export const ACCEPT_DECLINE_ACTION = "ACCEPT_DECLINE_ACTION"
export const LOVED_ONES= "LOVED_ONES"
export const CAREGIVERS = "CAREGIVERS"